var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 81,
    viewBox: "0 0 76 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1988 68.5272C52.0259 74.799 44.894 78.9334 36.7964 78.9334C23.9347 78.9334 13.5081 68.5062 13.5081 55.6451C13.5081 48.2339 16.9707 41.6323 22.3672 37.3668L20.9811 51.4607L50.9543 60.4265L56.1988 68.5272ZM26.3853 19.6025L13.1306 24.9592L0 40.9386L5.88387 45.9564L19.1374 31.7103L25.2563 31.0694L23.4119 49.8269L52.3983 58.497L66.9523 80.9792L75.809 77.1403L60.9448 47.7195L40.7542 41.2158L44.3778 18.4843L36.6039 15.5757L26.3844 19.6011L26.3853 19.6025ZM41.9302 0C46.0694 0 49.4247 3.35426 49.4247 7.4933C49.4247 11.6323 46.0693 14.9878 41.9302 14.9878C37.791 14.9878 34.4357 11.6323 34.4357 7.4933C34.4357 3.35426 37.7912 0 41.9302 0V0Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisability);
export default __webpack_public_path__ + "static/media/disability.99b4ceec51f2818b27fbdfd5a499ae2e.svg";
export { ForwardRef as ReactComponent };